import {
  DatabaseOutlined,
  TableOutlined,
  ShopOutlined,
  CarryOutOutlined,
  FileDoneOutlined,
  MoneyCollectOutlined,
} from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import BlankLayout from "layouts/BlankLayout";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";

const routes: IRouteConfig[] = [
  {
    path: "/advertiser",
    name: "advertiser.title",
    icon: ShopOutlined,
    component: BlankLayout,
    permissions: [
      [Resource.PROGRAM, Permission.VIEW],
      [Resource.PROGRAM, Permission.FULL_VIEW],
      [Resource.ADVERTISER_INVOICE, Permission.VIEW],
      [Resource.ADVERTISER_INVOICE, Permission.FULL_VIEW],
      [Resource.ADVERTISER_PAYMENT, Permission.FULL_VIEW],
      [Resource.ADVERTISER_PAYMENT, Permission.VIEW],
      [Resource.TOPUP, Permission.FULL_VIEW],
      [Resource.TOPUP, Permission.VIEW],
    ],
    routes: [
      {
        path: "/advertiser/contract",
        // defaultSearch: "s=clicks.desc",
        name: "contract.title",
        icon: TableOutlined,
        component: lazy(() => import("./pages/Contract")),
        permissions: [
          [Resource.ADVERTISER_CONTRACT, Permission.VIEW],
          [Resource.ADVERTISER_CONTRACT, Permission.FULL_VIEW],
        ],
        exact: true,
        placeholderConfig: {
          picker: true,
        },
      },
      {
        path: "/advertiser/contract/:id",
        // defaultSearch: "s=clicks.desc",
        name: "contract.title",
        icon: TableOutlined,
        component: lazy(() => import("./pages/Contract/pages/ContractDetail")),
        permissions: [
          [Resource.ADVERTISER_CONTRACT, Permission.VIEW],
          [Resource.ADVERTISER_CONTRACT, Permission.FULL_VIEW],
        ],
        hideInMenu: true,
        exact: true,
        placeholderConfig: {
          picker: true,
        },
      },
      {
        path: "/advertiser/contract/:id/edit",
        // defaultSearch: "s=clicks.desc",
        name: "contract.title",
        icon: TableOutlined,
        component: lazy(() => import("./pages/Contract/pages/ContractCompose")),
        permissions: [
          [Resource.ADVERTISER_CONTRACT, Permission.UPDATE],
          [Resource.ADVERTISER_CONTRACT, Permission.FULL_UPDATE],
        ],
        hideInMenu: true,
        exact: true,
        placeholderConfig: {
          picker: true,
        },
      },
      {
        path: "/advertiser/program",
        // defaultSearch: "s=clicks.desc",
        name: "advertiser.program.title",
        icon: TableOutlined,
        component: lazy(() => import("./pages/ProgramList")),
        permissions: [
          [Resource.PROGRAM, Permission.VIEW],
          [Resource.PROGRAM, Permission.FULL_VIEW],
        ],
        exact: true,
        placeholderConfig: {
          picker: true,
        },
      },
      {
        path: "/advertiser/program/create",
        name: "advertiser.program.new_program",
        exact: true,
        hideInMenu: true,
        component: lazy(
          () => import("pages/GetLink/pages/Program/pages/ProgramCompose")
        ),
        searchable: true,
        permissions: [
          [Resource.PROGRAM, Permission.CREATE],
          [Resource.PROGRAM, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/advertiser/program/:id/build-link",
        name: "advertiser.program.build_link",
        component: lazy(
          () =>
            import("pages/GetLink/pages/BuildLink/pages/BuildLinkWithProgram")
        ),
        searchable: false,
        hideInMenu: true,
        exact: true,
        permissions: [
          [Resource.CAMPAIGN_UNIVERSAL, Permission.CREATE],
          [Resource.CAMPAIGN_UNIVERSAL, Permission.FULL_CREATE],
        ],
      },
      {
        path: "/advertiser/program/:id/edit",
        name: "advertiser.program.title",
        component: lazy(
          () => import("pages/GetLink/pages/Program/pages/ProgramCompose")
        ),
        hideInMenu: true,
        searchable: false,
        exact: true,
        permissions: [
          [Resource.PROGRAM, Permission.UPDATE],
          [Resource.PROGRAM, Permission.FULL_UPDATE],
        ],
      },
      {
        path: "/advertiser/program/:id/:tab",
        name: "advertiser.program.title",
        component: lazy(
          () => import("./pages/ProgramList/pages/ProgramListDetail")
        ),
        hideInMenu: true,
        searchable: false,
        exact: true,
        permissions: [
          [Resource.PROGRAM, Permission.FULL_VIEW],
          [Resource.PROGRAM, Permission.VIEW],
        ],
      },
      {
        path: "/advertiser/crosscheck",
        name: "advertiser.crosscheck.title",
        icon: CarryOutOutlined,
        component: BlankLayout,
        permissions: [
          [Resource.ADVERTISER_INVOICE, Permission.VIEW],
          [Resource.ADVERTISER_INVOICE, Permission.FULL_VIEW],
          [Resource.ADVERTISER_PAYMENT, Permission.FULL_VIEW],
          [Resource.ADVERTISER_PAYMENT, Permission.VIEW],
        ],
        routes: [
          {
            path: "/advertiser/crosscheck/invoice",
            name: "advertiser.crosscheck.invoice.title",
            icon: FileDoneOutlined,
            component: lazy(
              () => import("pages/Advertiser/pages/Crosscheck/Invoice")
            ),
            searchable: true,
            exact: true,
            permissions: [
              [Resource.ADVERTISER_INVOICE, Permission.VIEW],
              [Resource.ADVERTISER_INVOICE, Permission.FULL_VIEW],
            ],
            placeholderConfig: {
              filter: true,
            },
          },
          {
            path: "/advertiser/crosscheck/invoice/:id/:tab",
            name: "advertiser.crosscheck.invoice.title",
            component: lazy(
              () =>
                import(
                  "pages/Advertiser/pages/Crosscheck/Invoice/pages/InvoiceDetail"
                )
            ),
            searchable: false,
            hideInMenu: true,
            exact: true,
            permissions: [
              [Resource.ADVERTISER_INVOICE, Permission.VIEW],
              [Resource.ADVERTISER_INVOICE, Permission.FULL_VIEW],
            ],
          },
          {
            path: "/advertiser/crosscheck/payment",
            name: "advertiser.crosscheck.payment.title",
            icon: MoneyCollectOutlined,
            component: lazy(() => import("./pages/Crosscheck/Payment")),
            searchable: true,
            exact: true,
            permissions: [
              [Resource.ADVERTISER_PAYMENT, Permission.FULL_VIEW],
              [Resource.ADVERTISER_PAYMENT, Permission.VIEW],
            ],
            placeholderConfig: {
              filter: true,
            },
          },
          {
            path: "/advertiser/crosscheck/payment/:id",
            name: "advertiser.crosscheck.payment.title",
            component: lazy(
              () => import("./pages/Crosscheck/Payment/pages/PaymentDetail")
            ),
            exact: true,
            hideInMenu: true,
            permissions: [
              [Resource.ADVERTISER_PAYMENT, Permission.FULL_VIEW],
              [Resource.ADVERTISER_PAYMENT, Permission.VIEW],
            ],
          },
          {
            path: "*",
            component: lazy(() => import("components/base/Errors/NotFound")),
            hideInMenu: true,
          },
        ],
      },
      ...require("./pages/Topup/routes").default,
      {
        path: "*",
        component: lazy(() => import("components/base/Errors/NotFound")),
        hideInMenu: true,
      },
    ],
  },
];

export default routes;
